import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicOverlayService } from 'src/app/shared/services/dynamic-overlay/dynamic-overlay.service';
import { UploadParams } from 'src/app/shared/services/upload/upload.service';
import { ContentStateService } from 'src/app/views/content/content-state.service';
import { CreateChunkOptionsOverlayData } from '../create-chunk-options-overlay/create-chunk-options-overlay.component';

@Component({
  selector: 'app-chunk-file-uploader',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressBarModule, MatTooltipModule, TranslateModule],
  template: `
    <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />

    @switch (displayMode) {
      @case ('interactive') {
        <div class="interactive-item" (click)="fileInput.click()">
          <div class="interactive-item__content">
            <div class="interactive-item__prefix"></div>
            <mat-icon class="interactive-item__icon" aria-hidden="true">{{ itemIcon }}</mat-icon>
            <span class="interactive-item__text">{{ itemText | translate }}</span>
          </div>
        </div>
      }
      @case ('icon') {
        <button mat-icon-button (click)="fileInput.click()" [matTooltip]="itemText | translate">
          <mat-icon>{{ itemIcon }}</mat-icon>
        </button>
      }
    }
  `,
  styles: [],
})
export class ChunkFileUploaderComponent {
  @Input() params: UploadParams;
  @Input() data: CreateChunkOptionsOverlayData;
  @Input() displayMode: 'interactive' | 'icon' = 'interactive';
  @Output() uploadComplete = new EventEmitter<void>();

  itemText = 'Chunk.Uploader.UploadFile';
  itemIcon = 'upload_file';

  private contentStateService = inject(ContentStateService);
  private overlay = inject(DynamicOverlayService);

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      const insertId = this.data.chunkAboveId ?? null;
      const insertAsFirst = !this.data.chunkAboveId ? true : false;

      this.contentStateService.uploadFile(file, insertId, insertAsFirst);
      this.overlay.close();
    }
  }
}
